import axios from 'axios'

import store from '@/store'
import { getToken } from '@/utils/auth'
import { handleApiError } from '@/utils/api-error'

const service = axios.create({
  baseURL: process.env.VUE_APP_V2_BASE_API,
  timeout: 25000
})

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers.Authorization = 'Bearer ' + getToken()
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    return response
  },
  handleApiError
)

export default service
